<div class="container-background container-fluid content">
  <div class="row">
    <h2 class="page-title col-12">Création d'un nouvel équipement</h2>
  </div>
  <div class="m-2 p-4 bg-white rounded">
    @if (form) {
      <form [formGroup]="form" (ngSubmit)="save()">
        <fieldset>
          <legend>Informations principales</legend>
          <div class="row">
            @if (form.get('nom'); as control) {
              <div class="mb-3 col-12 col-lg-12">
                <label class="form-label" for="nom">Nom *</label>
                <input class="form-control" id="nom" type="text" formControlName="nom" placeholder="Nom"
                  autocomplete="false" [ngClass]="{'is-invalid': !control.valid}"/>
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
            @if (form.get('description'); as control) {
              <div class="mb-3 col-12 col-lg-12">
                <label class="form-label" for="description">Description</label>
                <textarea class="form-control" id="description" formControlName="description" placeholder="Description"
                autocomplete="false" [ngClass]="{'is-invalid': !control.valid}"></textarea>
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
            @if (form.get('image'); as control) {
              <div class="mb-3 col-12 col-lg-12">
                <label class="form-label" for="image">Image</label>
                <input class="form-control" id="image" type="file" formControlName="image" accept="image/*"
                  [ngClass]="{'is-invalid': !control.valid}" (change)="uploadFile($event, 'image')" />
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
          </div>
        </fieldset>
        <fieldset>
          <legend>Fabriquant</legend>
          <div class="row">
            @if (form.get('reference'); as control) {
              <div class="mb-3 col-12 col-lg-12">
                <label class="form-label" for="reference">Référence</label>
                <input class="form-control" id="reference" type="text" formControlName="reference" placeholder="Référence"
                  autocomplete="false" [ngClass]="{'is-invalid': !control.valid}" />
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
            @if (form.get('urlFabriquant'); as control) {
              <div class="mb-3 col-12 col-lg-12">
                <label class="form-label" for="urlFabriquant">Url du fabriquant</label>
                <input class="form-control" id="urlFabriquant" type="text" formControlName="urlFabriquant"
                  placeholder="Url du fabriquant" autocomplete="false" [ngClass]="{'is-invalid': !control.valid}" />
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
            @if (form.get('notice'); as control) {
              <div class="mb-3 col-12 col-lg-12">
                <label class="form-label" for="notice">Notice</label>
                <input class="form-control" id="notice" type="file" formControlName="notice" placeholder="Notice"
                  [ngClass]="{'is-invalid': !control.valid}" (change)="uploadFile($event, 'notice')" />
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
          </div>
        </fieldset>
        <fieldset>
          <legend>Entretiens</legend>
          <div class="row">
            @if (form.get('entretienFaitPar'); as control) {
              <div class="mb-3 col-12 col-lg-6">
                <label class="form-label" for="entretienFaitPar">Entretien fait par</label>
                <select class="form-control" id="entretienFaitPar" formControlName="entretienFaitPar"
                  [ngClass]="{'is-invalid': !control.valid}">
                  <option value="0">Professionnel</option>
                  <option value="1">Occupant</option>
                </select>
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
            @if (form.get('periodiciteEntretien'); as control) {
              <div class="mb-3 col-12 col-lg-6">
                <label class="form-label" for="periodiciteEntretien">Périodicité de l'entretien (en mois)</label>
                <input class="form-control" id="periodiciteEntretien" type="number" formControlName="periodiciteEntretien"
                  placeholder="Notice" [ngClass]="{'is-invalid': !control.valid}"/>
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
          </div>
        </fieldset>
        <fieldset>
          <legend>Conseil</legend>
          <div class="row">
            @if (form.get('conseilMiseEnRoute'); as control) {
              <div class="mb-3 col-12 col-lg-12">
                <label class="form-label" for="conseilMiseEnRoute">Conseil de mise en route</label>
                <textarea class="form-control" id="conseilMiseEnRoute" formControlName="conseilMiseEnRoute"
                  placeholder="Conseil de mise en route" autocomplete="false"
                [ngClass]="{'is-invalid': !control.valid}"></textarea>
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
            @if (form.get('conseilEntretien'); as control) {
              <div class="mb-3 col-12 col-lg-12">
                <label class="form-label" for="conseilEntretien">Conseil d'entretien</label>
                <textarea class="form-control" id="conseilEntretien" formControlName="conseilEntretien"
                  placeholder="Conseil d'entretien" autocomplete="false"
                [ngClass]="{'is-invalid': !control.valid}"></textarea>
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
            @if (form.get('conseilsCasDePanne'); as control) {
              <div class="mb-3 col-12 col-lg-12">
                <label class="form-label" for="conseilsCasDePanne">Conseils en cas de panne</label>
                <textarea class="form-control" id="conseilsCasDePanne" formControlName="conseilsCasDePanne"
                  placeholder="Conseils en cas de panne" autocomplete="false"
                [ngClass]="{'is-invalid': !control.valid}"></textarea>
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
          </div>
        </fieldset>
        <div class="text-end mt-3">
          <button type="submit" class="btn btn-blue">Enregistrer</button>
        </div>
      </form>
    }
  </div>
</div>
